import React from 'react';
import PropTypes from 'prop-types';
import './TypingIndicator.css';

const TypingIndicator = ({ participantName }) => {
  return (
    <div className="TypingIndicator">
      <span className="typing-text">
        {participantName || 'Patient'} is typing...
      </span>
    </div>
  );
};

TypingIndicator.propTypes = {
  participantName: PropTypes.string
};

export default TypingIndicator;
